import React from 'react';
import SVGLoader, { SVGLoaderProps } from './SVGLoader';

const CallSharedIcon = ({
  width = 16,
  height = 16,
  viewboxWidth = 19,
  viewboxHeight = 18,
  ...rest
}: SVGLoaderProps) => {
  return (
    <SVGLoader
      {...rest}
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
    >
      <g fillRule="nonzero">
        <path d="M18.796 4.343a.356.356 0 01-.114.12l-4.448 3.49a.335.335 0 01-.262.055.347.347 0 01-.223-.156.407.407 0 01-.06-.188V5.828s-3.003-.864-6.173 3.045a.338.338 0 01-.491.038.378.378 0 01-.12-.3c.15-1.88 1.923-6.423 6.772-6.423V.346a.376.376 0 01.12-.255.344.344 0 01.258-.09.367.367 0 01.18.063l4.447 3.49a.577.577 0 01.114.79z" />
        <path d="M10.945 17.992c-1.447-.004-2.537-.434-3.56-1.06-1.64-1.006-2.966-2.369-4.112-3.926C2 11.277 1.011 9.396.424 7.306c-.298-1.062-.5-2.152-.396-3.26C.198 2.23.77.877 2.509.186c.958-.381 1.542-.187 2.109.685.486.75.886 1.542 1.126 2.414.148.54.03 1.01-.369 1.386-.302.284-.605.582-.953.795-.75.456-.846 1.131-.676 1.904.321 1.467 1.083 2.706 1.963 3.876.538.713 1.142 1.355 1.903 1.826.579.358 1.128.4 1.693-.042.334-.26.699-.48 1.06-.7.585-.357 1.155-.264 1.623.2.542.538 1.078 1.099 1.528 1.717.717.985.631 1.736-.215 2.62-.707.74-1.54 1.2-2.356 1.125" />
      </g>
    </SVGLoader>
  );
};

export default CallSharedIcon;
